import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import FactSource from './common/FactSource';
import TotalProductCount from './common/TotalProductCount';
// import OptInPopup from "../components/OptInPopup";
import config from "../../config";
import VideoLeftTextRight from "../components/page/VideoLeftTextRight";
import Testimonial from "./common/Testimonial";
import {buildEcomProductArrayForTopProducts, pushNewEcommerceEvent} from "../../utils/datalayer";
import InView from "../common/InView";

class Category extends Component {
	constructor(props) {
		super(props);
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}

	handleTopProductsInview() {
		const {featuredProduct} = this.props;
		const items = buildEcomProductArrayForTopProducts(featuredProduct, 'Water and Fireproof Safes');
		pushNewEcommerceEvent('view_item_list', items);
	}
	render() {
		const pageTitle = 'Water and Fireproof Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						title={`Best Selling ${pageTitle}`}
						subTitle="When the unimaginable happens, know your valuables are protected."
						path="fire-waterproof-safes"
						buttonCTA={`View all ${pageTitle}`}
						topProduct={this.props.featuredProduct}
					/>
				</InView>
			);
		}

		const videoTextData = {
			titleText: "SentrySafe Fireproof Safe vs. Other Brands",
			descriptionText: `<p><b>Watch the video</b> of our SentrySafe fireproof safe as it goes head-to-head with other brands in a one-hour fire test. Built to withstand temperatures up to 1700°, SentrySafe shows why it’s the only choice for protecting your valuables. <a href="/learn/fire-and-water-safes">Learn more about our next generation fireproof safes</a>.</p>`,
			// videoUrl: 'https://fbinsecurity.widen.net/view/video/tsnmwwj5je/?u=tbvfmm'
			videoUrl: 'https://fbinsecurity.widen.net/view/video/q7wfbu8cqu'
		};

		return (
			<div className="category category-water-and-fireproof">
				<Helmet defer={false}>
					<title>{pageTitle} &#124; SentrySafe</title>
					<meta name="description"
						  content="Family photos, jewelry, ID and business records—these can’t just be replaced. Water and fireproof safes protect your belongings should disaster strike. Shop now."/>
					<script async src={config.bazaarVoiceScriptUrl}/>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products"/>
					<BreadcrumbItem label={pageTitle}/>
				</Breadcrumb>

				<Hero
					imageSrc={require('../../resources/img/hero/water-and-fireproof-safes.jpg')}
					imageAlt="Couple moving into new home"
					title={pageTitle}
					description="Safeguard your belongings from the most unexpected perils."
				/>

				{/*<TrustedSection*/}
				{/*	content="It&rsquo;s not just fire that can threaten to damage your home. Whether you live in a flood plain, a hurricane rages through your town, or pipe bursts in your basement, a flood can happen to anyone. And protecting treasured valuables, cherished memories, and important business assets from the devastating effects of both water and fire damage is a top priority for many families. SentrySafe is proud to offer fire safes with various levels of waterproof and water&#45;resistant technology to ensure you have what you need if disaster strikes."*/}
				{/*/>*/}

				{topProducts}

				<section className="pb-1 mx-4 mx-xl-5" style={{
					borderTop: '1px solid #e0e1e2',
					borderBottom: '1px solid #e0e1e2',
				}}>
					<VideoLeftTextRight data={videoTextData}/>
				</section>

				<section className="row hour-test">
					<div className="col sm-12">
						<h3 className="title">The Most Reliable Fire and Water Protection</h3>
						<p className="descr">In addition to providing superior, <Link to="https://www.masterlock.com/insights/5-things-you-need-to-know-about-your-safes-fire-rating" target="_blank">UL-verified fire protection</Link> you can trust, our water and fireproof safes
							also safeguard against water damage.</p>
					</div>
					<div className="callouts">
						<div className="col sm-3">
							<h3 className="sub-title">Water Submersion Testing</h3>
							<p>Waterproof chests and files consistently deliver up to 72 hours of powerful protection
								from water intrusion. So even if you&rsquo;re stuck away from your home after a flood or
								hurricane, you&rsquo;ll know the things you value are safe.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">How Waterproofing Works</h3>
							<p>All SentrySafe waterproof products include a closed&#45;cell foam gasket. That means when
								the lid is closed, pressure forms a durable barrier between the water outside your safe
								and your valuables inside.</p>
						</div>
						<div className="col sm-3">
							<h3 className="sub-title">ETL Verified Protection</h3>
							<p>In addition to our own testing, the independent testing firm ETL thoroughly tests and
								verifies our water submersion and resistance ratings to ensure our safes protect against
								flooding and other water damage. SentrySafe products lead the industry in water
								protection, so you can rest assured your important documents, digital media, photos and
								keepsakes will survive catastrophe.</p>
						</div>
					</div>
				</section>


				<Testimonial
					imgSrc1={require('../../resources/img/callouts/testimonial-jason-f.jpg')}
					alt1={'Scott&rsquo;s Story'}
					imgSrc2={require('../../resources/img/callouts/testimonial-quote.png')}
					alt2={'Quote'}
					quote={'I&#39;ve owned the 3100 safe since I was 9 or 10 years old. Recently had a house fire where we lost everything&#8230;Our safe fell through 2 floors and was trapped in the rubble for 4 days. After letting it cool down, we cut through the steel&#8230;To my surprise, everything inside the safe was saved!'}
					submitted={'Jason F.'}
					readLink={'View all SentrySafe Stories'}
					link={'/learn/customer-stories'}
				/>

				<FactSource
					title="Did you know&#63;"
					fact="Floods are the &#35;1 natural disaster in the United States. And water damage is one of the most common claims on home insurance and it is estimated that your home has a 26&#37; chance of being damaged by a flood during the course of a 30&#45;year period. In fact, people outside of mapped high&#45;risk flood areas file over 20&#37; of all National Flood Insurance Program flood insurance claims."
					imgeSrc={require('../../resources/img/callouts/testimonial-flood.jpg')}
					alt="Burning House"
				/>

				<TotalProductCount
					link="fire-waterproof-safes"
					productTotal={totalCount}
					name={pageTitle}
				/>
				{/*<OptInPopup/>*/}
			</div>
		);
	}
}

export default branch({
	category       : ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/FireWaterproofCategory.js